<script>
import { mapActions, mapGetters } from 'vuex'

import StatusArrow from '@components/status-arrow.vue'

export default {
  components: {
    StatusArrow,
  },
  props: {
    position: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      loading: true,
      rawPlayers: [],
      headers: [
        {
          text: '#',
          value: 'number',
          width: 75,
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('ui', {
      defaultSeason: 'getDefaultSeason',
    }),
    players() {
      if (
        typeof this.rawPlayers === 'undefined' ||
        this.rawPlayers === '' ||
        !(this.rawPlayers instanceof Array)
      ) {
        return []
      }
      return this.rawPlayers.slice(0, 5).map((player) => {
        return {
          id: player.player_id,
          name: player.player_name,
          number: player.ranking + '°',
          history: player.history,
        }
      })
    },
  },
  watch: {
    defaultSeason: function() {
      this.loadData()
    },
  },
  async created() {
    this.loadData()
  },
  methods: {
    ...mapActions('players', ['getOverallRankingHistoryForPosition']),
    rowClick(player) {
      this.$router.push({
        name: 'player-profile',
        params: { playerId: player.id },
      })
    },
    loadData() {
      this.loading = true

      this.getOverallRankingHistoryForPosition({
        position: this.position,
      }).then((players) => {
        this.rawPlayers = players
        this.loading = false
      })
    },
  },
}
</script>

<template>
  <v-hover v-slot="{ hover }">
    <v-skeleton-loader v-if="loading" type="card-avatar" />
    <v-card
      v-else
      :elevation="hover ? 12 : 2"
      :class="[{ 'on-hover': hover }, $style.rankingCard]"
      tag="article"
    >
      <v-card-title :class="$style.rankingTitle">{{ position }}</v-card-title>
      <v-data-table
        dense
        :headers="headers"
        :items="players"
        :item-class="() => $style.playerRow"
        :hide-default-footer="true"
        :loading="!players"
        @click:row="rowClick"
      >
        <template slot="item" slot-scope="props">
          <tr :class="$style.playerRow">
            <td :class="$style.td">
              {{ props.item.number }}
              <StatusArrow
                v-if="props.item.history !== null"
                :status="props.item.history"
              />
            </td>
            <td :class="$style.td"
              ><router-link
                :to="{
                  name: 'player-profile',
                  params: { playerId: props.item.id },
                }"
              >
                {{ props.item.name }}</router-link
              ></td
            >
          </tr></template
        >

        <template slot="item.number" slot-scope="item">
          {{ item.item.ranking }}
        </template>
      </v-data-table>
    </v-card>
  </v-hover>
</template>

<style lang="scss" module>
@import '@design';

.td {
  height: 24px !important;
  border: 0 !important;

  a {
    color: $color-text;
    text-decoration: none;
  }
}

.rankingCard {
  @media screen and (min-width: $screen-md) {
    height: 20rem;
  }
}

.playerRow {
  height: 2.3rem;
  line-height: 1rem;
  cursor: pointer;
}

.rankingTitle {
  font-family: $heading-font-family;
  color: $color-secondary;
}
</style>
